// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bef_a bhm_rj bhm_rk bhm_vh bhm_eb bhm_vf bhm_gu bhm_kh"};